/**
 * Inlined locale strings. Bundling the 3 small dicts adds < 1 KB
 * gzipped to the widget; on-demand loading would cost a network round-trip
 * per first paint which is not worth it.
 */
type Locale = 'fr' | 'ar' | 'en';

const FR = {
  trackTitle: 'Suivi de votre colis',
  trackPlaceholder: 'Numéro de suivi',
  trackButton: 'Suivre',
  trackEmpty: 'Aucune information disponible pour ce numéro.',
  trackError: 'Erreur lors de la récupération du suivi.',
  trackEta: 'Livraison estimée',
  trackRefreshing: 'Mise à jour…',
  trackDelivered: 'Livré',
  ratesTitle: 'Tarifs disponibles',
  ratesEmpty: 'Aucun tarif disponible pour cet itinéraire.',
  ratesCompute: 'Calculer',
  ratesPostalFrom: 'CP expéditeur',
  ratesPostalTo: 'CP destinataire',
  ratesWeight: 'Poids (kg)',
  ratesSelect: 'Choisir',
  ratesSelected: 'Sélectionné',
  ratesError: 'Le service de tarification est indisponible.',
  checkoutConfirm: 'Confirmer la livraison',
  checkoutConfirmShort: 'Confirmer',
  checkoutChange: 'Modifier',
  checkoutTotal: 'Total',
  checkoutThanks: 'Merci, votre choix a été transmis.',
  poweredBy: 'Propulsé par TunisiaShip',
};
const EN: typeof FR = {
  trackTitle: 'Track your parcel',
  trackPlaceholder: 'Tracking number',
  trackButton: 'Track',
  trackEmpty: 'No information available for this number.',
  trackError: 'Failed to load tracking information.',
  trackEta: 'Estimated delivery',
  trackRefreshing: 'Refreshing…',
  trackDelivered: 'Delivered',
  ratesTitle: 'Available rates',
  ratesEmpty: 'No rates available for this route.',
  ratesCompute: 'Compute',
  ratesPostalFrom: 'Sender postcode',
  ratesPostalTo: 'Recipient postcode',
  ratesWeight: 'Weight (kg)',
  ratesSelect: 'Select',
  ratesSelected: 'Selected',
  ratesError: 'Rates service unavailable.',
  checkoutConfirm: 'Confirm delivery',
  checkoutConfirmShort: 'Confirm',
  checkoutChange: 'Change',
  checkoutTotal: 'Total',
  checkoutThanks: 'Thanks, your choice has been forwarded.',
  poweredBy: 'Powered by TunisiaShip',
};
const AR: typeof FR = {
  trackTitle: 'تتبع طردك',
  trackPlaceholder: 'رقم التتبع',
  trackButton: 'تتبع',
  trackEmpty: 'لا تتوفر معلومات لهذا الرقم.',
  trackError: 'تعذر تحميل بيانات التتبع.',
  trackEta: 'موعد التسليم المقدر',
  trackRefreshing: 'جارٍ التحديث…',
  trackDelivered: 'تم التسليم',
  ratesTitle: 'الأسعار المتاحة',
  ratesEmpty: 'لا تتوفر أسعار لهذا المسار.',
  ratesCompute: 'احسب',
  ratesPostalFrom: 'الرمز البريدي للمرسل',
  ratesPostalTo: 'الرمز البريدي للمستلم',
  ratesWeight: 'الوزن (كغ)',
  ratesSelect: 'اختر',
  ratesSelected: 'تم الاختيار',
  ratesError: 'خدمة التسعير غير متوفرة.',
  checkoutConfirm: 'تأكيد التسليم',
  checkoutConfirmShort: 'تأكيد',
  checkoutChange: 'تعديل',
  checkoutTotal: 'الإجمالي',
  checkoutThanks: 'شكراً، تم إرسال اختيارك.',
  poweredBy: 'مدعوم بـ TunisiaShip',
};

const TABLE: Record<Locale, typeof FR> = { fr: FR, en: EN, ar: AR };

export function strings(locale: Locale | undefined) {
  return TABLE[locale ?? 'fr'];
}

export function direction(locale: Locale | undefined): 'ltr' | 'rtl' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}
